function revShopPayStyles() {
  
    // Check if the <shopify-payment-terms> element is already present
    const paymentTermsElement = document.querySelector('shopify-payment-terms');
  
    if (paymentTermsElement) {
      // Element is present, handle it directly
      handlePaymentTermsElement(paymentTermsElement);
    } else {
      // Element is not present, set up the MutationObserver
      setupObserver();
    }
  
    function handlePaymentTermsElement(element) {
      const shadowRoot = element.shadowRoot;
  
      if (shadowRoot) {
        const installmentsBanner = shadowRoot.querySelector('shop-pay-installments-banner');
  
        if (installmentsBanner) {
          injectStyles(installmentsBanner.shadowRoot);
        } else {
          console.warn('shop-pay-installments-banner element not found');
        }
      } else {
        console.warn('Shadow root not found for shopify-payment-terms element');
      }
    }
  
    function injectStyles(targetRoot) {
      const styleElement = document.createElement('style');
      styleElement.textContent = `
        /* Shop Pay styles */
        .shopify-installments__learn-more {
          color: #006272;
          font-weight: 700;
        }
      `;
      targetRoot.appendChild(styleElement);
    }
  
    function setupObserver() {
      // Define a callback function to handle the mutation
      function handleMutation(mutations) {
        try {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              // Check if the added node is the <shopify-payment-terms> element
              if (node.nodeName === 'SHOPIFY-PAYMENT-TERMS') {
                console.log('SP node found');
                handlePaymentTermsElement(node);
  
                // Disconnect the observer, as we've found and styled the element
                observer.disconnect();
                clearTimeout(timeoutId); // Clear the timeout, as we've found the element
                console.log('close SP observer');
              }
            });
          });
        } catch (error) {
          console.error('Error injecting styles:', error);
        }
      }
  
      // Set a timeout to stop observing after a certain amount of time
      const timeoutDuration = 6000; // 6 seconds
      const timeoutId = setTimeout(() => {
        observer.disconnect(); // Stop observing if the element is not found within the timeout duration
        console.error('SP observer timeout');
      }, timeoutDuration);
  
      // Create a new MutationObserver instance
      const observer = new MutationObserver(handleMutation);
  
      // Configure the observer to watch for added nodes
      try {
        observer.observe(document.documentElement, {
          childList: true,
          subtree: true,
        });
      } catch (error) {
        console.error('Error setting up MutationObserver:', error);
      }
    }
  }
  
  revShopPayStyles();